var map = {
	"./algonet/summary.json": 9678,
	"./apollo-llm-analyser/summary.json": 3440,
	"./atlas-story-app/summary.json": 8715,
	"./turing-explorer/summary.json": 9854,
	"./turing-llm-1.0/summary.json": 971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6034;